<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('lottery_thai.head') }}</h2>
    </v-col>
    <v-col cols="12">
        <v-card>
            <v-col cols="12" class="d-flex flex-row px-6" style="background: #ffffff">
                <v-btn-toggle  v-model="tab" style="padding:12px">
                    <v-btn :value="0" :color="tab === 0 ? 'primary' : 'none'">{{ $t('lottery_thai.head_list') }}</v-btn>
                    <v-btn :value="1" :color="tab === 1 ? 'primary' : 'none'">{{ $t('lottery_thai.head_limit') }}</v-btn>
                    <v-btn :value="2" :color="tab === 2 ? 'primary' : 'none'">{{ $t('lottery_thai.head_result') }}</v-btn>
                </v-btn-toggle>
                <v-col cols="12" md="6" class="px-1">
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="px-1">
                      <span class="d-flex">
                        <date-picker-input
                          :date="dateFrom"
                          :label="$t('lottery_thai.date_from')"
                          @setValue="dateFrom = $event"
                        />
                      </span>
                    </v-col>
                    <v-col cols="12" md="6" class="px-1">
                      <span class="d-flex">
                        <date-picker-input
                          :date="dateTo"
                          :label="$t('lottery_thai.date_to')"
                          @setValue="dateTo = $event"
                        />
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
            </v-col>
            <lottery-thai-dashboard :dashboard="dashboard"></lottery-thai-dashboard>
        </v-card>
    </v-col>
    <v-col cols="12" v-if="tab === 0">
      <v-card>
        <v-card-title> {{ $t('lottery_thai.head_list') }} </v-card-title>
        <v-card-actions>
          <v-row no-gutters class="d-flex align-center justify-end">
            <v-spacer />
            <span class="px-3">ค้นหา:</span>
            <div style="width: 150px">
              <v-text-field v-debounce:500ms="searchKeyword" v-model="search" outlined dense hide-details />
            </div>
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :items="value"
            :no-data-text="$t('not_found')" :no-results-text="$t('not_found')" :options.sync="pagination"
            :server-items-length="pagination.totalItems" :items-per-page="pagination.rowsPerPage"
            :page.sync="pagination.page" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :loading="loading" :search="search">
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" v-if="tab === 1">
        <lottery-thai-limit :tab="tab" :canCreate="canCreate" :roundDateNow="roundDateSelect" :dateFrom="dateFrom" :dateTo="dateTo"></lottery-thai-limit>
    </v-col>
    <v-col cols="12" v-if="tab === 2">
        <lottery-thai-result :tab="tab" :canCreate="canCreate" :roundDateNow="roundDateSelect" :dateFrom="dateFrom" :dateTo="dateTo"></lottery-thai-result>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import TextInput from '@/components/input/TextInput.vue'
import store from '@/store'
import LotteryThaiLimit from '@/views/lottery-thai/LotteryThaiLimit.vue'
import LotteryThaiResult from '@/views/lottery-thai/LotteryThaiResult.vue'
import LotteryThaiDashboard from '@/views/lottery-thai/LotteryThaiDashboard.vue'

export default {
  components: {
    LotteryThaiLimit,
    LotteryThaiResult,
    LotteryThaiDashboard,
    DatePickerInput,
    TextInput,
  },

  data() {
    return {
      search: '',
      loading: false,
      canCreate: false,
      dateFrom: moment().format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      rules: [
        value => !!value || this.$t('alert_list.list1'),
        value => (!!value && /^\d+$/.test(value)) || this.$t('alert_list.list2'),
      ],
      headers: [
        {
          text: this.$t('lottery_thai.header1'),
          value: 'id',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
         text: this.$t('lottery_thai.header2'),
         value: 'roundDate',
         width: '100px',
         align: 'center',
         sortable: false,
        },
        {
          text: this.$t('lottery_thai.header3'),
          value: 'phone',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header4'),
          value: 'lotteryNumber',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header5'),
          value: 'quantity',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header6'),
          value: 'totalPrice',
          width: '100px',
          align: 'center',
          sortable: false,
        },
      ],
      value: [],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      dashboard:{}
    }
  },
  async created() {
    await this.getRoundDate()
    this.getDashboard()
    this.addLogPage()
    this.getPermissionsEdit()
  },
  watch: {
    dateFrom: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.loading = true
          await this.getDashboard()
          if (this.tab === 0) {
            await this.loadMemberData()
          }
          this.loading = false
        }
      }
    },
    dateTo: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.loading = true
          await this.getDashboard()
          if (this.tab === 0) {
            await this.loadMemberData()
          }
          this.loading = false
        }
      }
    },
    tab: {
      immediate: true,
      async handler(newTab) {
        this.loading = true;
        if (newTab === 0) {
          await this.loadMemberData();
        } else {
          await this.addLogPage(); // For tab 1 or 2
        }
        this.loading = false;
      }
    },
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if (cont && this.tab === 0) {
          this.loading = true
          this.value = []
          if(this.search){
            await this.getLotteryThaiMemberData(newValue.page, newValue.itemsPerPage, `&phone=${this.search}`)
          } else {
            await this.getLotteryThaiMemberData(newValue.page, newValue.itemsPerPage)
          }
          this.loading = false
        }
      },
      deep: true,
    },
  },
  methods: {
    async loadMemberData() {
      this.value = []; // clear before loading
      await this.getLotteryThaiMemberData(1, this.pagination.rowsPerPage);
    },
    async getRoundDate() {
      try {
        let result = await this.$store.dispatch('lotteryThai/getLotteryRound')
        let resData = result.data
        this.$store.commit('lotteryThai/setRoundDateSelect', resData.nowRound?.[0]?.round || resData.lastRound?.[0]?.round)
        this.$store.commit('lotteryThai/setRoundDate', resData.allRound || [])
      } catch (e) { }
    },
    async getDashboard() {
      try {
        let result = await this.$store.dispatch('lotteryThai/getLotteryDashboard',`from=${this.formatDateYYYY(this.dateFrom)}&to=${this.formatDateYYYY(this.dateTo)}`)
        let resData = result.data
        this.dashboard = resData;
      } catch (e) { }
    },
    async addLogPage() {
      try {
        let data
        let tab = this.tab
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          (data = {
            ip: res.data.ip,
            name: 'หวยไทย',
            url: window.location.href,
            detail: tab === 0 ? 'ข้อมูลการซื้อหวย' : tab === 1 ? 'ข้อมูลลิมิตหวย' : 'ข้อมูลผลรางวัลหวย',
            admin: userSystem.name ? userSystem.name : '',
          }),
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getLotteryThaiMemberData(page, row, searchQuery = '') {
      this.value = []
      try {
        let result = await this.$store.dispatch('lotteryThai/getLotteryMemberList', `page=${page}&rows=${row}&from=${this.formatDateYYYY(this.dateFrom)}&to=${this.formatDateYYYY(this.dateTo)}${searchQuery}`)
        let resData = result.data
        for (let i = 0; i < resData.length; i++) {
          let disabledResult = true

          function isEmptyValues(...values) {
            for (const value of values) {
              if (value === null || value === '') {
                return true
              }
            }
            return false
          }

          this.value.push({
            id: resData[i].id || null,
            roundDate: resData[i].roundDate || null,
            phone: resData[i].member.phone || null,
            lotteryNumber: resData[i].lotteryNumber || null,
            quantity: resData[i].quantity || null,
            totalPrice: resData[i].totalPrice || null,
            disabledResult: disabledResult,
          })
        }
        this.pagination.totalItems = result.count
      } catch (e) { }
    },
    async getPermissionsEdit() {
      let psSystem = store.getters.getPermissionsEdit
      let chkEdit = psSystem.filter(el => el === 'lotteryThai')
      if (chkEdit && chkEdit?.length > 0) {
        this.canCreate = true
      }
    },
    async findData() {
      this.loading = true
      const result = await this.getLotteryThaiMemberData(1, this.pagination.rowsPerPage);
      this.pagination.page = 1
      this.loading = false
    },
    async searchKeyword(value) {
       this.loading = true
       if (value) {
         await this.getLotteryThaiMemberData(1, this.pagination.rowsPerPage, `&phone=${value}`)
       } else {
         await this.getLotteryThaiMemberData(1, this.pagination.rowsPerPage)
       }
       this.pagination.page = 1
       this.loading = false
     },
    formatDate(date) {
      return moment(date).format('YY-MM-DD HH:mm')
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
  computed: {
    tab: {
        get() {
            return this.$store.state.lotteryThai.tab;
        },
        set(val) {
            this.$store.commit('lotteryThai/setActiveTab', val);
        }
    },
    roundDate: {
        get() {
            return this.$store.state.lotteryThai.roundDate;
        },
        set(val) {
            console.log('Setting roundDate:', val)
            this.$store.commit('lotteryThai/setRoundDate', val);
        }
    },
    roundDateSelect: {
        get() {
            return this.$store.state.lotteryThai.roundDateSelect;
        },
        set(val) {
            this.$store.commit('lotteryThai/setRoundDateSelect', val);
        }
    }
  },
}
</script>
